var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUserLogged && _vm.$route.name !== 'home')?_c('PageUser',[_c('router-view'),_c('Footer',{attrs:{"auth":""}})],1):_c('PagePublic',[_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }